import { CardApp, CardAppProps } from 'components/cardApp/CardApp';

import { DynamicImage, enLoading } from 'components/Image';
import { ImageProps } from 'next/image';
import { Wrapper } from 'components/wrapper';
import { isNotEmpty } from 'utility/functions';
import styles from './CardAppImage.module.scss';

export type CardAppImageProps = CardAppProps & {
  heroImage?: ImageProps;
};

export const CardAppImage = ({ heroImage, ...props }: CardAppImageProps) => {
  return (
    <Wrapper noPaddingTop={true}>
      <div className={styles.container}>
        {isNotEmpty(heroImage?.src) && (
          <div className={styles.heroImageContainer}>
            <DynamicImage
              src={`${heroImage?.src}`}
              alt={heroImage?.alt ?? ''}
              title={heroImage?.title ?? ''}
              fill
              loading={enLoading.lazy}
              decoding="async"
              className={styles.heroImage}
            />
          </div>
        )}
        {props.image && props.title && (
          <div className={styles.cardApp}>
            <CardApp
              image={props.image}
              title={props.title}
              description={props.description}
              urlDonwloadAppAndroid={props.urlDonwloadAppAndroid && props.urlDonwloadAppAndroid}
              urlDonwloadAppAndroidLabel={props.urlDonwloadAppAndroidLabel && props.urlDonwloadAppAndroidLabel}
              urlDonwloadAppIos={props.urlDonwloadAppIos && props.urlDonwloadAppIos}
              hasWrapper={props.hasWrapper}
            />
          </div>
        )}
      </div>
    </Wrapper>
  );
};
